export default function AcknowledgementBar() {
  return (
    <section
      data-testid="acknowledgement-bar"
      className="relative bg-charcoal text-sand py-10 md:py-12 border-b border-sand/10"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="text-[11px] uppercase tracking-[0.3em] text-ochre/85 mb-4">
          Acknowledgement of Country
        </div>
        <p className="font-serif text-lg md:text-xl text-sand/85 leading-relaxed italic font-light">
          We acknowledge the Traditional Custodians of the lands and waters on
          which we work — and pay our respects to Elders past, present and
          emerging. Sovereignty was never ceded.
        </p>
      </div>
    </section>
  );
}
